// extracted by mini-css-extract-plugin
module.exports = {"textA1":"textA1_textA1__lPr82"};